import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as catalanMessages } from "./ca";

const messages = {
	...englishMessages,
	...spanishMessages,
	...catalanMessages,
};

export { messages };
